import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export interface InfoModalAction {
  name: string;
  type: "default" | "primary" | "secondary";
  text: string;
}

export type InfoModalState = {
  id: string;
  title: string;
  actions?: InfoModalAction[];
};

export type ModalState = {
  info: InfoModalState | null;
};

export const initialModalState: ModalState = {
  info: null
};

const modalSlice = createSlice({
  name: "modal",
  initialState: initialModalState,
  reducers: {
    infoModalShown: (state, action: PayloadAction<InfoModalState>) => {
      state.info = action.payload;
    },
    infoModalHidden: (state) => {
      state.info = null;
    }
  }
});

export const { infoModalShown, infoModalHidden } = modalSlice.actions;

export const selectInfoModal = (state: RootState): InfoModalState | null =>
  state.modal.info;
export const selectIsInfoModalOpen = (state: RootState): boolean =>
  state.modal.info !== null;

export const modalReducer = modalSlice.reducer;
export default modalReducer;
